import { render, staticRenderFns } from "./TravelEditComponent.vue?vue&type=template&id=e04ad0a4"
import script from "./TravelEditComponent.vue?vue&type=script&lang=js"
export * from "./TravelEditComponent.vue?vue&type=script&lang=js"
import style0 from "./TravelEditComponent.vue?vue&type=style&index=0&id=e04ad0a4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports